import {
  Component,
  Prop,
  Vue,
  Watch,
  InjectReactive,
  Mixins
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
const Root = namespace("root");
@Component
export class specialChannel extends Vue {
  Tmall = "Tmall";
  isTmall(channel) {
    return channel === this.Tmall;
  }
}

@Component // 必须混入component ，否则无法mixin 成功
export class ProductChildren extends Vue {
  @Prop({ type: Function, required: false }) vaildateRegister;
  @Prop({ type: Function, required: false }) vaildateRemove;
  mounted() {
    // register vaildte function
    this.vaildateRegister((this as any).handleVaildate);
  }

  beforeDestroy() {
    this.vaildateRemove((this as any).handleVaildate);
  }
}
// 渠道商品个模块数据处理（初始化表单，验证表单，提交数据解析成接口需要的格式）
@Component
export class channelAttributeParse extends Mixins(specialChannel) {
  @InjectReactive("curChannel") curChannel;
  @InjectReactive("curBrandId") curBrandId;
  // @ProvideReactive("channelLocale") channelLocale: any = "";
  @Root.State languageList;
  // 0：单选；1：多选；2：输入框；3：数字；4：富文本；5：日期；6：对象；7：单选可输入；8：多选可输入，9：其他
  @Prop({ default: () => [] }) blockList;
  @Prop({ default: "" }) title;
  @Prop({ default: () => {} }) data: any;
  ruleForm: any = {};
  rules = {};
  channelLanguages = [];
  langInitObj = {};
  channelLocale = "";
  extendCode = "[AL]";
  get rulesPreset() {
    return {
      required: {
        required: true,
        message: this.$t("Basic.required_msg")
      },
      numValidate: { validator: this.numValidate, trigger: "change" },
      localeValidate: { validator: this.localeItemValidate, trigger: "change" }
    };
  }
  // 验证数字
  numValidate(rule, value, callback) {
    const val = Number(value);
    if (isNaN(val)) {
      let error: any = this.$t("Basic.required_num_msg");
      callback(new Error(error));
    } else {
      callback();
    }
  }
  // 多语言验证方法
  localeItemValidate(rule, value, callback) {
    let all = this.isAllMultiLang(this.channelLanguages, value);
    if (!value || !all) {
      let info: any = this.$t("Basic.required_msg");
      callback(new Error(info));
    }
    callback();
  }
  resItemValue({ code, locale = "", value, isMultiple = false }) {
    let list = isMultiple
      ? value
      : [
          {
            channelAttrValue: value
          }
        ];
    let result: any = {
      channelAttrCode: code,
      attrValueList: list
    };
    if (locale) {
      result.locale = locale;
    }
    return result;
  }
  // 提交表单
  resFormart() {
    // console.log("resFormart", this.ruleForm);
    let result = this.handleResetFormItem(this.ruleForm);
    return result;
  }
  // 解析表单数据
  handleResetFormItem(form) {
    let result = [];
    this.blockList.forEach(block => {
      let { channelAttrCode } = block;
      let code = channelAttrCode.replace(/\./g, "+");
      // console.log(code, form[block.channelAttrCode]);
      // console.log(code, block.channelAttrCode, form[code]);
      // 多语言解析
      if (this.itemIsMultiLang(block)) {
        this.channelLanguages.forEach(lang => {
          result.push(
            this.resItemValue({
              code: block.channelAttrCode,
              locale: lang.value,
              value: form[this.getMultiKey(block)][lang.value]
            })
          );
        });
      }
      // 多选数组解析 + 图片/视频数组 + checkbox
      else if (
        [1, 8, 15].includes(block.attrValueType) ||
        (block.attrCode === "images" &&
          !this.isTmall(this.curChannel.channelCode))
      ) {
        let valueList = form[code];
        if (valueList.length > 0) {
          let resList = [];
          valueList.forEach(value => {
            resList.push({ channelAttrValue: value });
          });
          result.push(
            this.resItemValue({
              code: block.channelAttrCode,
              value: resList,
              isMultiple: true
            })
          );
        }
      }
      // 数字
      else if (block.attrValueType === 3) {
        result.push(
          this.resItemValue({
            code: block.channelAttrCode,
            value: form[code] ? Number(form[code]) : null
          })
        );
      }
      // 其他
      else {
        result.push(
          this.resItemValue({
            code: block.channelAttrCode,
            value: form[code]
          })
        );
      }
    });

    return result;
  }
  // 结构渲染列表数据监听
  @Watch("blockList", { immediate: true, deep: true })
  watchBlockList(blockList) {
    if (blockList && blockList.length > 0) {
      this.ruleForm = {};
      this.initBlock(blockList, this.ruleForm, this.data);
    }
  }
  initBlock(blockList, form, data) {
    blockList.forEach((_, index) => {
      // 初始化表单
      let keyCode = this.getMultiKey(_);
      // 是否多语言属性
      if (this.itemIsMultiLang(_)) {
        // 获取渠道多语言列表
        this.getChannelLanguages(_);
      }

      this.setInitForm(form, keyCode, _, data);
    });
  }
  // 初始化单个表单数据和rule
  setInitForm(form, keyCode, node, data) {
    let itemValue = this.initFormItem(node, data);
    this.$set(form, keyCode, itemValue);
    if (!this.rules[keyCode]) {
      let itemRule = this.initFormItemRule(node);
      this.$set(this.rules, keyCode, itemRule);
    }
  }
  // 判断单个属性是否多语言
  itemIsMultiLang(node) {
    return node.languages && node.languages.length > 0;
  }
  // 多语言属性在ruleForm 里的多语言对象key 值
  getMultiKey(node) {
    let pattern = /\./;
    let code = node.channelAttrCode;
    if (pattern.test(node.channelAttrCode)) {
      code = node.channelAttrCode.replace(/\./g, "+");
    }
    return this.itemIsMultiLang(node) ? `${code}Locale` : code;
  }
  // 多语言属性在ruleForm 里的prop 路径值
  getMultiProp(node) {
    let pattern = /\./;
    let code = node.channelAttrCode;
    if (pattern.test(node.channelAttrCode)) {
      code = node.channelAttrCode.replace(/\./g, "+");
    }
    // console.log(
    //   this.itemIsMultiLang(node) ? this.getMultiKey(node) : code,
    //   "prop"
    // );
    return this.itemIsMultiLang(node) ? this.getMultiKey(node) : code;
  }
  // 获取渠道多语言列表
  getChannelLanguages(node) {
    if (this.channelLanguages.length === 0) {
      this.langInitObj = {};
      node.languages.forEach(lang => {
        if (lang === "default") {
          this.channelLanguages.push(this.languageList[0]);
          this.$set(this.langInitObj, this.languageList[0].value, "");
        } else {
          if (
            !this.channelLanguages.filter(item => item.value === lang).length
          ) {
            let list = this.languageList.filter(item => item.value === lang);
            if (list.length) {
              this.channelLanguages.push(list[0]);
              this.$set(this.langInitObj, list[0].value, "");
            }
          }
        }
      });

      if (this.channelLanguages.length > 0) {
        // 配置第一个默认多语言
        this.channelLocale = this.channelLanguages[0].value;
        localStorage.setItem("channelLocale", this.channelLocale);
      }
    }
  }
  // 根据属性类型获取初始值
  initFormItem(node, data) {
    let keyCode = node.channelAttrCode;
    let dataItem = data[keyCode];
    if (
      node.attrCode === "images" &&
      !this.isTmall(this.curChannel.channelCode)
    ) {
      let result = [];
      if (dataItem) {
        result = dataItem[this.extendCode] || [];
      }
      return result;
    } else if (
      node.attrCode === "brandCode" &&
      this.isTmall(this.curChannel.channelCode)
    ) {
      return this.curBrandId;
    } else if ([1, 8, 15].includes(node.attrValueType)) {
      let result = [];
      if (dataItem) {
        result = dataItem[this.extendCode] || [];
      }
      return result;
      // return [];
    } else if (node.attrValueType === 3) {
      let result = null;
      if (dataItem) {
        result = dataItem[this.extendCode][0] || null;
      }
      return result;
    } else {
      if (this.itemIsMultiLang(node)) {
        let result = { ...this.langInitObj };
        if (dataItem) {
          this.channelLanguages.forEach(_ => {
            result[_.value] = dataItem[_.value][0] || "";
          });
        }
        return result;
      } else {
        let result = "";
        if (dataItem) {
          result = dataItem[this.extendCode][0] || "";
        }
        return result;
      }
    }
  }
  // 根据属性类型获取验证规则
  initFormItemRule(item) {
    let result: any = [];
    // 多语言验证 必填
    if (this.itemIsMultiLang(item) && item.attrIsRequired) {
      result.push(this.rulesPreset.localeValidate);
    }
    // 必填验证
    item.attrIsRequired &&
      typeof item.attrValueType === "number" &&
      result.push(this.rulesPreset.required);
    // 数字验证
    item.attrValueType === 3 && result.push(this.rulesPreset.numValidate);
    // 多选验证
    [1, 8].includes(item.attrValueType) &&
      result.push({ type: "array", trigger: "change" });

    return result;
  }
  // 验证属性多语言是否全部填写
  isAllMultiLang(langList, localeObj) {
    // console.log(localeObj, "localeObj");

    return langList.every(_ => {
      let value = localeObj[_.value];
      return !!value;
    });
  }
}
@Component
export class channelAttrImages extends Vue {
  curNode = {};
  curEditValue: any = [];

  // 编辑图片
  editImages(value, node) {
    this.curNode = node;
    this.curEditValue = value;
    (this.$refs.channelSkuMediaDialog as any).visible = true;
  }
  saveChannelImages(list) {
    (this as any).ruleForm[(this as any).getMultiKey(this.curNode)] = list;
    this.curNode = {};
    this.curEditValue = [];
  }
}
